import { Axios } from '@/shared/api/axiosInstance.ts';
import type { TenantConfig } from '@/tenant/types/tenant';

const fetchTenantConfig = (tenantId: string): Promise<TenantConfig> => {
  return Axios.get<any, TenantConfig>(`/tenants/${tenantId}/config`);
};

export { fetchTenantConfig };
